"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.16663 3.3332H5.66663C4.26649 3.3332 3.56643 3.3332 3.03165 3.60568C2.56124 3.84536 2.17879 4.22782 1.93911 4.69822C1.66663 5.233 1.66663 5.93307 1.66663 7.3332V14.3332C1.66663 15.7333 1.66663 16.4334 1.93911 16.9682C2.17879 17.4386 2.56124 17.821 3.03165 18.0607C3.56643 18.3332 4.26649 18.3332 5.66663 18.3332H12.6666C14.0668 18.3332 14.7668 18.3332 15.3016 18.0607C15.772 17.821 16.1545 17.4386 16.3941 16.9682C16.6666 16.4334 16.6666 15.7333 16.6666 14.3332V10.8332M6.6666 13.3332H8.06206C8.46971 13.3332 8.67353 13.3332 8.86535 13.2871C9.03541 13.2463 9.19798 13.179 9.3471 13.0876C9.5153 12.9845 9.65942 12.8404 9.94767 12.5521L17.9166 4.5832C18.607 3.89284 18.607 2.77355 17.9166 2.0832C17.2263 1.39284 16.107 1.39284 15.4166 2.0832L7.44765 10.0521C7.1594 10.3404 7.01527 10.4845 6.9122 10.6527C6.82082 10.8018 6.75348 10.9644 6.71265 11.1345C6.6666 11.3263 6.6666 11.5301 6.6666 11.9378V13.3332Z",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;